import { useTranslation } from 'react-i18next';

import { FilterBar } from '@/components/shared/FilterBar';
import { BadgeSelect } from '@/components/ui/daisy';
import { VersioningStatusUIEnum } from '@/enums/VersioningStatus';
import { mapStatusToColor, mapStatusToVariant } from './PedContentStatus';

export type PedContentFilterBarProps = {
  status?: VersioningStatusUIEnum;
  onStatusChange: (status?: VersioningStatusUIEnum) => void;
  total: number;
};

export default function PedContentFilterBar({
  status,
  onStatusChange,
  total,
}: PedContentFilterBarProps) {
  const { t } = useTranslation('translation', { keyPrefix: 'courses.status' });
  const { t: tCommon } = useTranslation('translation', { keyPrefix: 'common' });
  const { t: tFilterBar } = useTranslation('translation', {
    keyPrefix: 'filterBar',
  });

  return (
    <div className="flex items-center justify-between gap-4">
      <FilterBar>
        <FilterBar.Fields className="w-53.5">
          <BadgeSelect
            placeholder={tCommon('status')}
            value={status ?? ''}
            onChange={value =>
              onStatusChange((value as VersioningStatusUIEnum) || undefined)
            }
            onClear={() => onStatusChange(undefined)}
          >
            {Object.values(VersioningStatusUIEnum).map(value => (
              <BadgeSelect.Option
                key={value}
                value={value}
                color={mapStatusToColor[VersioningStatusUIEnum[value]]}
                variant={mapStatusToVariant[VersioningStatusUIEnum[value]]}
              >
                {t(value === VersioningStatusUIEnum.DRAFT ? 'NEW' : value)}
              </BadgeSelect.Option>
            ))}
          </BadgeSelect>
        </FilterBar.Fields>
      </FilterBar>

      <div className="text-sm leading-5 shrink-0">
        {tFilterBar('results', { shown: total, count: total })}
      </div>
    </div>
  );
}
